import { useState } from "react";
import { forgotPassword } from "./AuthService";

export default function ForgotPassword(){

  const [username,setUsername] = useState("");

  const submit = async (e)=>{
    e.preventDefault();
    await forgotPassword(username);
    alert("Password reset link sent");
  };

  return (
    <form onSubmit={submit}>
      <h2>Forgot Password</h2>

      <input placeholder="Username or Email" onChange={e=>setUsername(e.target.value)} required />
      <button type="submit">Send Reset Link</button>
    </form>
  );
}
